import { useState } from 'react';
import { useCallback } from 'react';
import { useEffect } from 'react';
import { createContext, ReactNode, useContext } from 'react';

import { PowerCreator } from '~/models/PowerCreator';
import api from '~/services/api';

type RequestData = {
  data: PowerCreator[];
};

type PowerCreatorData = {
  powerCreator: PowerCreator;
  powerCreators: PowerCreator[];
  selectPowerCreator: (value: PowerCreator) => void;
  updatePowerCreators: () => void;
};

export const PowerCreatorContext = createContext({} as PowerCreatorData);

type Props = {
  children: ReactNode;
};

export function PowerCreatorProvider({ children }: Props) {
  const [powerCreator, setPowerCreator] = useState<PowerCreator>(
    {} as PowerCreator,
  );
  const [powerCreators, setPowerCreators] = useState<PowerCreator[]>(
    {} as PowerCreator[],
  );

  const loadPowerCreators = useCallback(async () => {
    const { data } = await api.get<RequestData>('power-creators', {
      params: { perpage: 99999 },
    });

    setPowerCreators(data.data);
  }, []);

  useEffect(() => {
    loadPowerCreators();
  }, [loadPowerCreators]);

  function selectPowerCreator(value: PowerCreator) {
    setPowerCreator(value);
  }

  const updatePowerCreators = useCallback(() => {
    loadPowerCreators();
  }, [loadPowerCreators]);

  return (
    <PowerCreatorContext.Provider
      value={{
        powerCreator,
        powerCreators,
        selectPowerCreator,
        updatePowerCreators,
      }}
    >
      {children}
    </PowerCreatorContext.Provider>
  );
}

export function usePowerCreator(): PowerCreatorData {
  const context = useContext(PowerCreatorContext);

  if (!context) {
    throw new Error(
      `usePowerCreator must be use within a PowerCreatorProvider!`,
    );
  }

  return context;
}
